module.exports = __webpack_public_path__ + "static/media/akshat.994b2470.jpeg";